import { render, staticRenderFns } from "./baseCount.vue?vue&type=template&id=a9fc53e4&scoped=true&"
import script from "./baseCount.vue?vue&type=script&lang=js&"
export * from "./baseCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fc53e4",
  null
  
)

export default component.exports